<label
  [for]="labelForId()"
  class="col-form-label col-form-label-sm"
  [ngClass]="{ 'u-required': isRequired(), 'd-none': !label() }"
  >{{ label() }}</label
>
@if (file() || attachmentName()) {
  <div
    class="alert alert-primary m-0 d-flex justify-content-between align-items-center"
    role="alert"
  >
    <span class="d-block">{{
      attachmentName() ? attachmentName() : file()?.name
    }}</span>
    <button
      class="btn btn-light text-danger c-button__icon"
      (click)="clearFile()"
    >
      <span class="material-symbols-rounded">delete</span>
    </button>
  </div>
} @else {
  <div
    class="c-img__container"
    (click)="fileInfo.click()"
    appDragDrop
    (keydown)="(null)"
    (onFileDropped)="uploadFileDrop($event)"
  >
    <input
      hidden
      type="file"
      [name]="labelForId()"
      [id]="labelForId()"
      #fileInfo
      [accept]="allowedFiles()"
      (change)="uploadFile($event)"
    />
    <span class="c-img__icon material-symbols-rounded">{{ icon() }}</span>
    <span class="c-img__title mx-3">{{ title() }}</span>
    <!-- <span class="c-img__subtitle mb-0 mx-3">Peso máximo: {{ fileMaxSizeMb() }}MB</span> -->
    <span class="c-img__subtitle mb-0 mx-3"
      >Formatos permitidos: {{ extensions() }}</span
    >
    <button
      type="button"
      class="c-button__base btn btn-outline-base mb-0 mt-2 ml-3 mr-3"
    >
      Seleccionar un archivo
    </button>
  </div>
}
